/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc
 */

export const BasicBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.BasicBillableMetricTypeUsage';
export const DetailedBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.DetailedBillableMetricTypeUsage';
export let ComHubspotUsagebasedbillingExperienceCore;
(function (_ComHubspotUsagebasedbillingExperienceCore) {})(ComHubspotUsagebasedbillingExperienceCore || (ComHubspotUsagebasedbillingExperienceCore = {}));
export let ComHubspotUsagebasedbillingExperienceRpcModels;
(function (_ComHubspotUsagebasedbillingExperienceRpcModels) {})(ComHubspotUsagebasedbillingExperienceRpcModels || (ComHubspotUsagebasedbillingExperienceRpcModels = {}));
export const getUsagePeriodUsageWithTargetPortalRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getUsagePeriodUsageWithTargetPortal',
  auth: 'app',
  fingerprint: '_MkyDHL6qJxPWaHxJN6XHhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonChargeableUsagePeriodUsageWithTargetPortalRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getNonChargeableUsagePeriodUsageWithTargetPortal',
  auth: 'app',
  fingerprint: '_MkyDHL6qJzqQI7ABqAjlhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getHistoricalUsagePeriodUsage',
  auth: 'app',
  fingerprint: 'P4iBgoIePKpzpEHY2ry6FBUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalNonChargeableUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getHistoricalNonChargeableUsagePeriodUsage',
  auth: 'app',
  fingerprint: 'P4iBgoIePKpA4xfCLH8IxhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByFeatureCategoryWithTargetPortalRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getHistoricalByFeatureCategoryWithTargetPortal',
  auth: 'app',
  fingerprint: 'WkCAIRuab4tF1diw-w6m9xUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonChargeableHistoricalByFeatureCategoryWithTargetPortalRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getNonChargeableHistoricalByFeatureCategoryWithTargetPortal',
  auth: 'app',
  fingerprint: 'WkCAIRuab4tF1diw-w6m9xUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByBillableMetricTypeWithTargetPortalRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getHistoricalByBillableMetricTypeWithTargetPortal',
  auth: 'app',
  fingerprint: 'uWfLJGJvIKSBoIiQLAZ9NxUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllBillableMetricChargingEligibilityRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceCrossHubletRpc',
  rpcName: 'getAllBillableMetricChargingEligibility',
  auth: 'app',
  fingerprint: 'ci1RWlsix5csJ8tSa4FGYxUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};